export interface Audit
{
    id: number;
    auditId: number;
    objectId: number;
    date: Date;
    author: string;
    property: string;
    left: string;
    right: string;
}
